/**
 * Turn a confirmed-field value into a human-readable string per the field's
 * type. Used by the review summary screen.
 */

import type { Language } from '../api/types';
import type { ProgramField } from '../config/types';

export function formatFieldValue(
  field: ProgramField,
  value: unknown,
  language: Language,
): string {
  if (value === null || value === undefined || value === '') return '';

  switch (field.type) {
    case 'text':
    case 'date':
      return String(value);
    case 'number':
      return typeof value === 'number' ? String(value) : String(value);
    case 'boolean':
      return value === true || value === 'true' ? 'Yes' : 'No';
    case 'select': {
      const key = String(value);
      const match = field.options?.find((o) => o.key === key);
      return match ? (match.label[language] ?? key) : key;
    }
    case 'multi': {
      const arr = Array.isArray(value) ? value : [];
      return arr
        .map((k) => {
          const match = field.options?.find((o) => o.key === String(k));
          return match ? (match.label[language] ?? String(k)) : String(k);
        })
        .join(', ');
    }
  }
}
